import { Link } from "react-router-dom";
import Routes from "../utils/routes.ts";

export default function Header() {

  return (
    <header className="flex justify-between items-center">
      <div className="text-2xl font-bold flex gap-2 items-center ">

          {import.meta.env.VITE_VMS_APP_LOGO_URL && <img src={import.meta.env.VITE_VMS_APP_LOGO_URL} className='size-12 object-contain'/>}

        <span className={`text-primary`}>{import.meta.env.VITE_VMS_APP_NAME}</span>{" "}
        <span className="text-black">EVENTS</span>
      </div>
      <div className="flex items-center space-x-4">

        <Link
          to={`/${Routes["Evenements de l'utilisateur"]}`}
          className={`text-white font-bold bg-third px-4 py-1 bg-opacity-60 rounded-full`}
        >
          <p>Mes tickets</p>
        </Link>
      </div>
    </header>
  );
}
